import { createAction } from '@reduxjs/toolkit';
export const UPDATE_CALL_SESSION = 'UPDATE_CALL_SESSION';
export const updateCallSessionAction = createAction(UPDATE_CALL_SESSION);